export type IMaskNumberFields = IDCA.IGenericFunc;

export function _maskNumberFields(): void {
  $('input.number-field').each((_, input) => {
    const $input = $(input);
    if ($input.data('mask')) {
      return;
    }
    const size = $input.attr('size') ? Number($input.attr('size')) : 30;
    const isDisabled = $input.is('readonly') || $input.is('disabled');
    // build mask string. Ex: 0000000
    const maskString = window.DexeroCoreApp.padWithZero('', size);
    const mask = $input.data('field-mask') || maskString;
    if (!isDisabled) {
      setTimeout(() => {
        ($input as any).mask(mask);
      }, 0);
    }
  });
}
